<template>
	<div class="cargo-card">
		<div class="row-1">
			<div class="column-1">
				<div>Рейс № {{ trip?.number }}</div>
				<div
					class="card"
					v-if="trip?.car"
				>
					<div class="card-name">{{ trip?.car?.name }}</div>
					<div class="card-number">{{ trip?.car?.stateNumber }}</div>
				</div>
			</div>
			<div class="column-2">
				<Icon
					name="mynaui:location"
					color="#1C3363"
					class="cargo-town"
				/>
				<div
					v-for="(city, index) in trip?.intermediateCityNames"
					:key="city"
					class="city"
				>
					{{ city }}
					<Icon
						v-if="index + 1 !== trip?.intermediateCityNames?.length"
						name="uil:arrow-right"
						class="arrow-icon"
					/>
				</div>
			</div>
			<div class="column-3">
				<Icon
					name="solar:box-minimalistic-linear"
					color="#1C3363"
					class="cargo-count-icon"
				/>
				{{ trip.countCargos }}
			</div>
		</div>
		<div class="row-2">
			<div class="column column-1">
				<div class="title">Дата отправления</div>
				<div class="description">
					<UiIcon
						name="calendar"
						color="#757484"
						additional-color="#757484"
						width="10px"
						height="10px"
					/>
					<div class="date">{{ getTripDate(trip?.dtDeparture) }}</div>
					<Icon
						name="ic:baseline-access-time"
						color="#757484"
						:style="{ fontSize: '12px', marginLeft: '4px' }"
					/>
					<div class="time">{{ getTripTime(trip?.dtDeparture) }}</div>
				</div>
			</div>
			<div class="column column-2">
				<div class="title">Дата прибытия</div>
				<div class="description">
					<UiIcon
						name="calendar"
						color="#757484"
						additional-color="#757484"
						width="10px"
						height="10px"
					/>
					<div class="date">{{ getTripDate(trip?.dtArrive) }}</div>
					<Icon
						name="ic:baseline-access-time"
						color="#757484"
						:style="{ fontSize: '12px', marginLeft: '4px' }"
					/>
					<div class="time">{{ getTripTime(trip?.dtArrive) }}</div>
				</div>
			</div>
			<div class="column column-3">
				<div class="item">
					<div class="title">Вес, т</div>
					<div class="description">
						{{ trip?.totalWeight }}
					</div>
				</div>
				<div class="item">
					<div class="title">Объем, м³</div>
					<div class="description">
						{{ trip?.totalVolume }}
					</div>
				</div>
			</div>
			<div class="column column-4">
				<div class="item">
					<div class="title">Клиенты</div>
					<div class="description">
						{{ trip?.countClients }}
					</div>
				</div>
				<div class="item">
					<div class="title">СНТ</div>
					<div
						class="description"
						:style="{ color: '#7044C8' }"
					>
						{{ trip?.countSnt }} / {{ trip?.countCargos }}
					</div>
				</div>
			</div>
		</div>
		<div class="row-3">
			<div
				class="column column-1"
				@click="passCustomModal"
				v-if="!trip?.customsPassed"
			>
				<div class="column-wrapper">
					<Icon name="fluent-emoji-high-contrast:customs" />
					<div class="title">Таможня</div>
				</div>
			</div>
			<div
				v-else
				class="column column-4"
				@click="addedTalonModal"
			>
				<div class="column-wrapper">
					<Icon name="fluent:ticket-diagonal-16-regular" />
					<div class="title">Талон</div>
				</div>
			</div>
			<div
				class="column column-2"
				@click="addedSntModal"
			>
				<div class="column-wrapper">
					<Icon name="solar:document-line-duotone" />
					<div class="title">Документы СНТ</div>
				</div>
			</div>
			<div
				class="column column-3"
				@click="openArrived"
			>
				<div class="column-wrapper">
					<Icon name="hugeicons:maps-location-01" />
					<div class="title">Прибытие</div>
				</div>
			</div>
		</div>
		<div
			class="badge__custom-passed"
			v-if="trip?.customsPassed"
		>
			<div class="wrapper">
				<Icon
					name="material-symbols:verified-rounded"
					color="#3CB3AD"
					:style="{ fontSize: '17px' }"
				/>
				<div class="title">таможня пройдена {{ getDateInLocaleString(trip?.dtCustomsPassed, { showTime: true }) }}</div>
			</div>
		</div>
		<div class="row-4">
			<UiButton
				:color="ButtonType.primary"
				:size="ButtonSizeType.medium"
				label="Подробно о рейсе"
				@click="goToCargoDetail"
			/>
		</div>
		<UiModalConfirm
			v-if="modalOpen.passCustoms"
			v-model="modalOpen.passCustoms"
			:title="`Подтвердить прохождение таможни?`"
			:subtitle="`После подтверждения кнопка подтверждения изменит название на “Талон”`"
			:btnConfirmTitle="`Подтвердить`"
			:is-loading="loading.confirmPassCustom"
			:is-need-save-btn="true"
			@save="confirmPassCustom"
		>
		</UiModalConfirm>
		<PagesTruckerAddedTalonModal
			v-if="modalOpen.addedTalonModal"
			v-model="modalOpen.addedTalonModal"
			:current-trip="trip"
		/>
		<PagesTruckerSntModal
			v-if="modalOpen.sntModal"
			v-model="modalOpen.sntModal"
			:current-trip="trip"
		/>

		<UiModalConfirm
			v-if="modalOpen.confirmArrived"
			v-model="modalOpen.confirmArrived"
			:title="`Подтвердить прибытие?`"
			:subtitle="`После подтверждения рейс будет отмечен как прибывший и перемещен в историю`"
			:btnConfirmTitle="`Подтвердить`"
			:is-loading="loading.confirmPassCustom"
			:is-need-save-btn="true"
			@save="confirmArrivedHandler"
		>
			<template #customIcon>
				<Icon
					name="hugeicons:maps-location-01"
					color="#3B6DD3"
					:style="{ fontSize: '22px' }"
				/>
			</template>
		</UiModalConfirm>
	</div>
</template>

<script setup lang="ts">
	import { useLongHaulTripStore } from '~/store/longHaulTrip.store';
	import type { ITrip } from '~~/shared/interfaces/truck';
	import { ButtonSizeType, ButtonType } from '~~/shared/interfaces/ui';
	import { getDateInLocaleString } from '../../../helpers/date';

	const props = withDefaults(defineProps<{ trip: ITrip }>(), {});
	const emits = defineEmits(['getTripsOnTheWay']);
	const getTripDate = (value?: string) => value?.match(/^\d{4}-\d{2}-\d{2}/)?.[0] || value || '-';
	const getTripTime = (value?: string) => value?.match(/[T ](\d{2}:\d{2})/)?.[1] || '--:--';
	const modalOpen = reactive({
		passCustoms: false,
		addedTalonModal: false,
		sntModal: false,
		confirmArrived: false
	});
	const loading = reactive({
		confirmPassCustom: false
	});

	const router = useRouter();
	const longHaulTripStore = useLongHaulTripStore();

	const addedSntModal = () => {
		modalOpen.sntModal = true;
	};

	const confirmArrivedHandler = async () => {
		const response = await longHaulTripStore.setArriveTrip({ tripId: props.trip?.id });

		if (response.status === 'success') {
			modalOpen.confirmArrived = false;
			emits('getTripsOnTheWay', true);
			longHaulTripStore.clearTripsOnTheWayById(props.trip?.id);
		}
	};

	const addedTalonModal = () => {
		modalOpen.addedTalonModal = true;
	};

	const confirmPassCustom = async () => {
		loading.confirmPassCustom = true;

		const response = await longHaulTripStore.markCustomsPassed({
			tripId: props.trip?.id
		});

		if (response.status === 'success') {
			modalOpen.passCustoms = false;
			emits('getTripsOnTheWay', true);
		}

		loading.confirmPassCustom = false;
	};

	const openArrived = () => {
		modalOpen.confirmArrived = true;
	};

	const passCustomModal = async () => {
		modalOpen.passCustoms = true;
	};

	const goToCargoDetail = () => {
		router.push(`/trucker/${props.trip?.id}`);
	};
</script>

<style scoped lang="scss">
	.row-4 {
		margin-top: 10px;
		width: 100%;

		.ui-button {
			width: 100%;
		}
	}
	.badge__custom-passed {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		border: 1px solid #3cb3ad;
		margin-top: 10px;
		border-radius: 8px;
		padding: 2px;

		.wrapper {
			display: flex;
			align-items: center;
			gap: 8px;
			background-color: #daf3f1;
			border-radius: 6px;
			width: 100%;
			padding: 2px 7px;

			.title {
				color: #3cb3ad;
				font-size: 10px;
			}
		}
	}

	.row-3 {
		display: flex;
		justify-content: space-between;
		gap: 5px;
		margin-top: 12px;

		.column {
			position: relative;
			min-height: 58px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			width: 100%;
			border-radius: 16px;
			font-size: 13px;
			cursor: pointer;
			transition: all linear 0.3s;

			.column-wrapper {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				text-align: center;
				border-radius: 14px;
				gap: 4px;
				width: calc(100% - 4.2px);
				height: calc(100% - 4.2px);
			}

			&-1 {
				border: 1.2px solid #4bc3bd;
				color: #3cb3ad;

				svg {
					color: #2aa49e;
				}

				.column-wrapper {
					background-color: #daf3f1;

					&:hover {
						background-color: #aaddda;
					}
				}
			}

			&-2 {
				border: 1.2px solid #8d6ad4;
				color: #8d6ad4;

				svg {
					color: #7044c8;
				}

				.column-wrapper {
					background-color: #e0e1fb;

					&:hover {
						background-color: #c2c4e8;
					}
				}
			}

			&-3 {
				border: 1.2px solid #4180ff;
				color: #4180ff;

				svg {
					color: #3b6dd3;
				}

				.column-wrapper {
					background-color: #e0ebff;

					&:hover {
						background-color: #c3d5fb;
					}
				}
			}

			&-4 {
				border: 1.2px solid #0096cd;
				color: #0096cd;

				svg {
					color: #0096cd;
				}

				.column-wrapper {
					background-color: #ddeeff;

					&:hover {
						background-color: #b1ceeb;
					}
				}
			}
		}
	}
	.row-2 {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 8px;
		color: #757484;
		margin-top: 10px;

		.column-3,
		.column-4 {
			display: grid !important;
			gap: 8px !important;
			grid-template-columns: 1fr 1fr;
			background-color: transparent !important;
			border-radius: 0px !important;
			padding: 0px 0px !important;

			.item {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				background-color: #f3f4fb;
				border-radius: 6px;
				padding: 5px 6px;
				min-height: 45px;
			}

			.description {
				font-weight: 600;
				font-size: 14px;
			}
		}

		.column {
			display: flex;
			flex-direction: column;
			gap: 2px;
			background-color: #f3f4fb;
			border-radius: 6px;
			padding: 5px 6px;
		}

		.title {
			font-size: 10px;
		}
		.description {
			display: flex;
			align-items: center;
			gap: 0px;
			font-size: 10px;
			color: #303733;
			line-height: 12px;
			font-weight: 600;

			.date {
				margin-bottom: -2px;
				margin-left: 3px;
			}
			.time {
				margin-bottom: -2px;
				margin-left: 2px;
			}
		}
	}

	.city {
		display: flex;
		align-items: center;
		color: #273167;
		font-size: 12px;
	}
	.cargo-town {
		margin-right: 8px;
	}

	:deep(.arrow-icon path) {
		stroke-width: 10;
	}

	:deep(.cargo-town path) {
		stroke-width: 2;
	}
	:deep(.cargo-count-icon path) {
		stroke-width: 2;
	}

	.cargo-card {
		background-color: #ffffff;
		padding: 14px 15px;
		border-radius: 16px;
	}

	.row-1 {
		display: grid;
		grid-template-columns: 1fr min-content min-content;
		gap: 2px;
		width: 100%;

		.card {
			display: flex;
			gap: 4px;
			align-items: center;
			background-color: #bdd0ea;
			padding: 2px 2px;
			border-radius: 4px;

			&-name {
				font-size: 8px;
				color: #303733;
				font-weight: 500;
			}
			&-number {
				font-size: 8px;
				color: #303733;
				background-color: #ffffff;
				border-radius: 3px;
				padding: 0px 4px;
				height: 10px;
				line-height: 1.2;
				font-weight: 500;
			}
		}

		.column-1 {
			display: flex;
			align-items: center;
			gap: 6px;
			background: #dbeafe;
			width: max-content;
			grid-row: 1/1;
			grid-column: 1/1;
			border-radius: 8px 8px 0px 0px;
			padding: 5px 10px;
			font-weight: 700;
			font-size: 14px;
			height: 29px;
			color: #1c3363;
		}

		.column-2 {
			display: flex;
			flex-wrap: wrap;
			gap: 0px;
			align-items: center;
			background-color: #dbeafe;
			width: 100%;
			grid-row: 2/2;
			grid-column: 1/3;
			border-radius: 0px 8px 8px 8px;
			padding: 5px 10px;
			height: fit-content;
			min-height: 29px;
		}

		.column-3 {
			display: flex;
			gap: 5px;
			align-items: center;
			grid-row: 1/1;
			grid-column: 2/2;
			color: #2e4a85;
			font-weight: 700;
		}
	}
</style>
